export default "__VITE_ASSET__KHbLqPS6__"